/**
 * Arthaus mega-nav — animated drill-down panels (Shop Art / Rooms).
 * Hover-intent open/close, keyboard accessible, with a hover-swappable featured image.
 */
(function () {
  'use strict';
  function init() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var wrap = header.querySelector('[data-mega-panels]');
    if (!wrap) return;

    var triggers = Array.prototype.slice.call(header.querySelectorAll('[data-mega]'));
    var panels = {};
    wrap.querySelectorAll('[data-mega-panel]').forEach(function (p) { panels[p.getAttribute('data-mega-panel')] = p; });
    var openName = null, closeTimer = null;

    // ── Featured image swap (Art panel) ──
    var art = panels.art;
    var fImg = art && art.querySelector('[data-mega-feature-img]');
    var fTitle = art && art.querySelector('[data-mega-feature-title]');
    var fLink = art && art.querySelector('[data-mega-feature-link]');
    var defImg = fImg && fImg.getAttribute('src');
    var defTitle = fTitle && fTitle.textContent;
    var defLink = fLink && fLink.getAttribute('href');
    function restoreFeature() {
      if (fImg && defImg) { fImg.src = defImg; fTitle.textContent = defTitle; fLink.setAttribute('href', defLink); }
    }

    function setOpen(name) {
      clearTimeout(closeTimer);
      if (openName === name) return;
      Object.keys(panels).forEach(function (k) {
        var on = k === name;
        panels[k].classList.toggle('is-open', on);
        panels[k].setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', t.getAttribute('data-mega') === name ? 'true' : 'false'); });
      header.classList.toggle('mega-open', !!name);
      if (!name) restoreFeature();
      openName = name;
    }
    function scheduleClose() { clearTimeout(closeTimer); closeTimer = setTimeout(function () { setOpen(null); }, 160); }

    triggers.forEach(function (t) {
      var name = t.getAttribute('data-mega');
      t.addEventListener('mouseenter', function () { setOpen(name); });
      t.addEventListener('focus', function () { setOpen(name); });
      t.addEventListener('mouseleave', scheduleClose);
    });
    Object.keys(panels).forEach(function (k) {
      panels[k].addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      panels[k].addEventListener('mouseleave', scheduleClose);
    });

    if (art && fImg) {
      art.querySelectorAll('[data-mega-hero]').forEach(function (a) {
        a.addEventListener('mouseenter', function () {
          fImg.src = a.getAttribute('data-mega-hero');
          if (fTitle) fTitle.textContent = a.getAttribute('data-mega-title') || defTitle;
          if (fLink) fLink.setAttribute('href', a.getAttribute('href'));
        });
      });
    }

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(null); });
    document.addEventListener('click', function (e) { if (openName && !header.contains(e.target)) setOpen(null); });
    window.addEventListener('scroll', function () { if (openName) setOpen(null); }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
